import React from 'react';
import { KeyRound, AlignLeft } from 'lucide-react';

/**
 * Секция ввода текста для хеширования
 */
const InputSection = ({
  formData,
  handleInputChange,
  errors
}) => {
  return (
    <div className="mb-6">
      <div className="flex items-center mb-2">
        <AlignLeft className="w-4 h-4 mr-2 text-blue-500" />
        <label 
          htmlFor="plaintext" 
          className="block text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          Пароль или текст для хеширования
        </label>
      </div>
      
      <div className="relative">
        <textarea
          id="plaintext"
          name="plaintext"
          value={formData.plaintext}
          onChange={handleInputChange}
          disabled={formData.autoGenerate}
          rows="3"
          placeholder={formData.autoGenerate 
            ? "Текст будет сгенерирован автоматически" 
            : "Введите пароль или текст для хеширования"}
          className={`form-textarea w-full ${errors.plaintext ? 'input-error' : ''} ${formData.autoGenerate ? 'bg-gray-100 dark:bg-gray-800' : ''}`}
          aria-invalid={errors.plaintext ? "true" : "false"}
        />
        <KeyRound className="absolute top-3 right-3 w-5 h-5 text-gray-400 dark:text-gray-500" />
      </div>
      
      {errors.plaintext && (
        <p className="mt-1 text-xs text-red-500 dark:text-red-400">
          {errors.plaintext}
        </p>
      )}
      
      {!errors.plaintext && (
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          {formData.autoGenerate 
            ? "Пароль будет сгенерирован автоматически с заданными настройками" 
            : "Рекомендуется использовать пароли длиной минимум 8 символов, содержащие буквы разного регистра, цифры и специальные символы"}
        </p>
      )}
    </div>
  );
};

export default InputSection;